import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/verify.svg'


const _hoisted_1 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-grow-1 ms-2" }
const _hoisted_7 = { class: "fs-12" }
const _hoisted_8 = { class: "fw-semibold fs-14 mb-0" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "fs-12 d-block mb-1" }
const _hoisted_12 = { class: "fw-semibold text-secondary" }
const _hoisted_13 = { class: "fw-semibold fs-14 mb-0" }
const _hoisted_14 = { class: "bg-transparent p-0 border-0" }
const _hoisted_15 = { class: "text-secondary fs-12 fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      spaceBetween: 25,
      centeredSlides: false,
      preventClicks: true,
      loop: false,
      autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
      navigation: {
      prevEl: '.prev',
      nextEl: '.next',
    },
      pagination: {
      clickable: true,
    },
      breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 3,
      },
      1440: {
        slidesPerView: 4,
      },
      1600: {
        slidesPerView: 4,
      },
    },
      modules: _ctx.modules,
      class: "nft-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftItem, (nft) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, {
            key: nft.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: nft.image,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, 8, _hoisted_2),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1))
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          src: nft.creator.image,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        }, null, 8, _hoisted_5)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, " NFT ID: " + _toDisplayString(nft.creator.id), 1),
                        _createElementVNode("h4", _hoisted_8, _toDisplayString(nft.creator.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_0,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          _cache[2] || (_cache[2] = _createTextVNode(" Highest Bid: ", -1)),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(nft.highestBid) + " ETH ", 1)
                        ]),
                        _createElementVNode("h4", _hoisted_13, _toDisplayString(nft.bid) + " ETH", 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("button", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(nft.rating) + " ", 1),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-body" }, "/10", -1))
                    ])
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"nft-controller\"><div class=\"controller-icon prev\"><i class=\"ri-arrow-left-line\"></i></div><div class=\"controller-icon next\"><i class=\"ri-arrow-right-line\"></i></div></div>", 1))
  ], 64))
}